export default __webpack_public_path__ + "static/media/36.9b00c6f6.jpg";